module.exports = __webpack_public_path__ + "img/Webflow_logo.ef4ac96d.svg";